
import { useUser } from '@/contexts/UserContext';
import { useManagerPermissions } from '@/hooks/useManagerPermissions';
import { CalendarPermissions } from '../types';

export const useSchedulePermissions = (teamId: string) => {
  const { isAdmin, isManager } = useUser();
  const { canManageTeam, isLoading: isLoadingManagerPermissions } = useManagerPermissions(teamId);
  
  // Determine if user has admin-like permissions (admin, manager role, OR manager of this team)
  const hasAdminLikePermissions = isAdmin || isManager || canManageTeam;

  const permissions: CalendarPermissions = {
    canCreate: hasAdminLikePermissions,
    canUpdate: hasAdminLikePermissions,
    canDelete: hasAdminLikePermissions,
    canDrag: hasAdminLikePermissions
  };

  return {
    hasAdminLikePermissions,
    permissions,
    isLoadingManagerPermissions
  };
};
